module.exports = __webpack_public_path__ + "static/img/user.4bf0773.png";


//////////////////
// WEBPACK FOOTER
// ./src/cpassChat/user.png
// module id = cXZO
// module chunks = 1